import { gql } from '@apollo/client';

export const getSessionExpiredCollection = gql`
	query getVignettenFehlerseitenCollection($lang: String) {
		vignettenFehlerseitenCollection(locale: $lang, limit: 1) {
			items {
				sessionExpiredTitle
				sessionExpiredText
				sessionExpiredContinueLabel
				expiredPaymentTitle
				expiredPaymentText
			}
		}
	}
`;
